import styled from 'styled-components'

export default styled.section`
  p {
    margin: 0 0 16px;
    font-size: 14px;
    font-weight: bold;
  }

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 32px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .qr-code {
    width: 84px;
    height: 84px;
    padding: 8px;
    border-radius: 6px;
    box-sizing: border-box;
    background-color: ${ ({ theme }) => theme.colors.white };
  }

  .badge {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    min-width: 118px;
    min-height: 40px;
    padding: 4px 12px 4px 10px;
    box-sizing: border-box;
    border: 1px solid ${ ({ theme }) => theme.colors.greyMedium };
    border-radius: 7px;
    background-color: ${ ({ theme }) => theme.colors.black };
    color: ${ ({ theme }) => theme.colors.white };
    text-decoration: none;
    text-shadow: none;
  }

  .store-icon {
    flex: 0 0 auto;
    width: 20px;
    height: 22px;
    object-fit: contain;
  }

  .badge-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.1;
    white-space: nowrap;
  }

  .caption {
    font-size: 9px;
    font-weight: 500;

    &.googlePlay {
      text-transform: uppercase;
    }
  }

  .store-name {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.2px;
  }

  a.badge:focus-visible {
    outline: 2px solid ${ ({ theme }) => theme.colors.landingHighlight };
    outline-offset: 2px;
  }
`
